import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const applicationFormRouter: Array<RouteRecordRaw> = [
  {
    path: '/applicationForm',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      order: 2, // 导航栏权重
      title: 'applicationFormManagement',
      icon: '#iconyijicaidan',
      roles: [
        'APPLY_SUB_W',
        'APPLY_SAP_SR', 'APPLY_SAP_SW', 'APPLY_SAP_R', 'APPLY_SAP_W',
        'APPLY_SPPO_SR', 'APPLY_SPPO_SW', 'APPLY_SPPO_R', 'APPLY_SPPO_W',
        'APPLY_SPNPO_SR', 'APPLY_SPNPO_SW', 'APPLY_SPNPO_R', 'APPLY_SPNPO_W',
        'APPLY_EXP_SR', 'APPLY_EXP_SW', 'APPLY_EXP_R', 'APPLY_EXP_W',
        'APPLY_REFUND_SR', 'APPLY_REFUND_SW', 'APPLY_REFUND_R', 'APPLY_REFUND_W'
      ]
    },
    children: [
      {
        path: 'payment-request-sap/list',
        component: () => import(/* webpackChunkName: "paymentRequestSAPList" */ '@/views/application-form/payment-request-sap/PaymentRequestSAPList.vue'),
        name: 'PaymentRequestSapList',
        meta: {
          title: 'paymentRequestSAP',
          icon: '#iconerjicaidan',
          roles: ['APPLY_SAP_SR', 'APPLY_SAP_SW', 'APPLY_SAP_R', 'APPLY_SAP_W', 'APPLY_SUB_W'],
          keepAlive: true
        }
      },
      {
        path: 'special-payment-request-po',
        redirect: '/applicationForm/special-payment-request-po/list', // 重定向到默认子路由
        component: () => import(/* webpackChunkName: "specialPaymentRequestPO" */ '@/views/application-form/special-payment-request-po/Index.vue'),
        name: 'SpecialPaymentRequestPOIndex',
        meta: {
          title: 'specialPaymentRequestPO',
          icon: '#iconerjicaidan',
          roles: ['APPLY_SPPO_SR', 'APPLY_SPPO_SW', 'APPLY_SPPO_R', 'APPLY_SPPO_W', 'APPLY_SUB_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "specialPaymentRequestPOList" */ '@/views/application-form/special-payment-request-po/SpecialPaymentRequestPOList.vue'),
            name: 'SpecialPaymentRequestPOList',
            meta: {
              title: 'specialPaymentRequestPO',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['APPLY_SPPO_SR', 'APPLY_SPPO_SW', 'APPLY_SPPO_R', 'APPLY_SPPO_W', 'APPLY_SUB_W'],
              keepAlive: true
            }
          },
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "createSpecialPaymentRequestPO" */ '@/views/application-form/special-payment-request-po/CreateSpecialPaymentRequestPO.vue'),
            name: 'CreateSpecialPaymentRequestPO',
            meta: {
              title: 'createSpecialPaymentRequestPO',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_SPPO_SW', 'APPLY_SPPO_W']
            }
          },
          {
            path: 'update/:id',
            component: () => import(/* webpackChunkName: "updateSpecialPaymentRequestPO" */ '@/views/application-form/special-payment-request-po/UpdateSpecialPaymentRequestPO.vue'),
            name: 'UpdateSpecialPaymentRequestPO',
            meta: {
              title: 'updateSpecialPaymentRequestPO',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_SPPO_SW', 'APPLY_SPPO_W']
            }
          }
        ]
      },
      {
        path: 'special-payment-request-no-po',
        redirect: '/applicationForm/special-payment-request-no-po/list', // 重定向到默认子路由
        component: () => import(/* webpackChunkName: "SpecialPaymentRequestNoPO" */ '@/views/application-form/special-payment-request-no-po/Index.vue'),
        name: 'SpecialPaymentRequestNoPOIndex',
        meta: {
          title: 'specialPaymentRequestNoPO',
          icon: '#iconerjicaidan',
          roles: ['APPLY_SPNPO_SR', 'APPLY_SPNPO_SW', 'APPLY_SPNPO_R', 'APPLY_SPNPO_W', 'APPLY_SUB_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "specialPaymentRequestNoPOList" */ '@/views/application-form/special-payment-request-no-po/SpecialPaymentRequestNoPOList.vue'),
            name: 'SpecialPaymentRequestNoPOList',
            meta: {
              title: 'specialPaymentRequestNoPO',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['APPLY_SPNPO_SR', 'APPLY_SPNPO_SW', 'APPLY_SPNPO_R', 'APPLY_SPNPO_W', 'APPLY_SUB_W'],
              keepAlive: true
            }
          },
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "createSpecialPaymentRequestNoPO" */ '@/views/application-form/special-payment-request-no-po/CreateSpecialPaymentRequestNoPO.vue'),
            name: 'CreateSpecialPaymentRequestNoPO',
            meta: {
              title: 'createSpecialPaymentRequestNoPO',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_SPNPO_SW', 'APPLY_SPNPO_W']
            }
          },
          {
            path: 'update/:id',
            component: () => import(/* webpackChunkName: "updateSpecialPaymentRequestNoPO" */ '@/views/application-form/special-payment-request-no-po/UpdateSpecialPaymentRequestNoPO.vue'),
            name: 'UpdateSpecialPaymentRequestNoPO',
            meta: {
              title: 'updateSpecialPaymentRequestNoPO',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_SPNPO_SW', 'APPLY_SPNPO_W']
            }
          }
        ]
      },
      {
        path: 'reimbursement-request',
        redirect: '/applicationForm/reimbursement-request/list', // 重定向到默认子路由
        component: () => import(/* webpackChunkName: "supplierIndex" */ '@/views/application-form/reimbursement-request/Index.vue'),
        name: 'ReimbursementRequestIndex',
        meta: {
          title: 'reimbursementRequest',
          icon: '#iconerjicaidan',
          roles: ['APPLY_EXP_SR', 'APPLY_EXP_SW', 'APPLY_EXP_R', 'APPLY_EXP_W', 'APPLY_SUB_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "reimbursementRequestList" */ '@/views/application-form/reimbursement-request/ReimbursementRequestList.vue'),
            name: 'ReimbursementRequestList',
            meta: {
              title: 'reimbursementRequest',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['APPLY_EXP_SR', 'APPLY_EXP_SW', 'APPLY_EXP_R', 'APPLY_EXP_W', 'APPLY_SUB_W'],
              keepAlive: true
            }
          },
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "createSpecialPaymentRequestReimb" */ '@/views/application-form/reimbursement-request/CreateSpecialPaymentRequestReimb.vue'),
            name: 'CreateSpecialPaymentRequestReimb',
            meta: {
              title: 'createSpecialPaymentRequestReimb',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_EXP_SW', 'APPLY_EXP_W']
            }
          },
          {
            path: 'update/:id',
            component: () => import(/* webpackChunkName: "updateSpecialPaymentRequestReimb" */ '@/views/application-form/reimbursement-request/UpdateSpecialPaymentRequestReimb.vue'),
            name: 'UpdateSpecialPaymentRequestReimb',
            meta: {
              title: 'updateSpecialPaymentRequestReimb',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_EXP_SW', 'APPLY_EXP_W']
            }
          }
        ]
      },
      {
        path: 'payment-request-refund',
        redirect: '/applicationForm/payment-request-refund/list', // 重定向到默认子路由
        component: () => import(/* webpackChunkName: "paymentRequestRefundIndex" */ '@/views/application-form/payment-request-refund/Index.vue'),
        name: 'PaymentRequestRefundIndex',
        meta: {
          title: 'paymentRequestRefund',
          icon: '#iconerjicaidan',
          roles: ['APPLY_REFUND_SR', 'APPLY_REFUND_SW', 'APPLY_REFUND_R', 'APPLY_REFUND_W', 'APPLY_SUB_W']
        },
        children: [
          {
            path: 'list',
            component: () => import(/* webpackChunkName: "paymentRequestRefundList" */ '@/views/application-form/payment-request-refund/PaymentRequestRefundList.vue'),
            name: 'PaymentRequestRefundList',
            meta: {
              title: 'paymentRequestRefund',
              icon: '#iconerjicaidan',
              breadcrumb: false,
              roles: ['APPLY_REFUND_SR', 'APPLY_REFUND_SW', 'APPLY_REFUND_R', 'APPLY_REFUND_W', 'APPLY_SUB_W'],
              keepAlive: true
            }
          },
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "createPaymentRequestRefund" */ '@/views/application-form/payment-request-refund/CreatePaymentRequestRefund.vue'),
            name: 'CreatePaymentRequestRefund',
            meta: {
              title: 'createPaymentRequestRefund',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_REFUND_SW', 'APPLY_REFUND_W']
            }
          },
          {
            path: 'update/:id',
            component: () => import(/* webpackChunkName: "updatePaymentRequestRefund" */ '@/views/application-form/payment-request-refund/UpdatePaymentRequestRefund.vue'),
            name: 'UpdatePaymentRequestRefund',
            meta: {
              title: 'updatePaymentRequestRefund',
              hidden: true,
              noCache: true,
              icon: '#iconerjicaidan',
              roles: ['APPLY_REFUND_SW', 'APPLY_REFUND_W']
            }
          }
        ]
      }
    ]
  }
]
export default applicationFormRouter
